module.exports = __webpack_public_path__ + "static/media/unibest.fee8f1e3.jpg";